import {formulaFunctions} from '~/formulaFunctions';
import {IFormulaFunction} from "~/interfaces/formulaInterfaces";
import {ComparisonType} from "~/models/conditionalRules/comparisonType";

export const formulaFunctionHelper = {
  findFunctionData: function (formula: string): IFormulaFunction {
    if (!formula) return null;
    //Give precedence to logical formulas because functions used in conditional check do not necessarily match output
    if (formulaFunctions.filter(f => f.type === "logical").find(funcData => formula.includes(funcData.name + '(')) ){
      return formulaFunctions.filter(f => f.type === "logical").find(funcData => formula.includes(funcData.name + '('))
    }else{
      return formulaFunctions.find(funcData => formula.includes(funcData.name + '('));
    }
  },
  effectiveComparisonType: function (formula: string): ComparisonType {
    const functionData = this.findFunctionData(formula);
    if (!functionData) return null;
    switch (functionData.type) {
      case "string":
        return ComparisonType.text;
      case "math":
        return ComparisonType.numeric;
      case "datetime":
        return ComparisonType.datetime;
      case "logical":
        const functionCall = formula.match(new RegExp(functionData.name + '[(][^)]+[)]'));
        if (functionCall[0].match(/,[ ]*[0-9].*,/) ){
          return ComparisonType.numeric
        }else{
          return ComparisonType.text
        }
        break;
      default:
        return ComparisonType.text;
    }
  },
};